import { useEffect, EffectCallback } from "react";
import {
  useDispatch as rrUseDispatch,
  useSelector as rrUseSelector,
  shallowEqual,
  TypedUseSelectorHook,
} from "react-redux";

export const useMount = (effect: EffectCallback) => useEffect(effect, []);

type GetStateType<TStore> = TStore extends { getState: () => infer TState } ? TState : unknown;
type GetDispatchType<TStore> = TStore extends { dispatch: infer TDispatch } ? TDispatch : unknown;

export const createReduxHooks = <
  TStore,
  TState = GetStateType<TStore>,
  TDispatch = GetDispatchType<TStore>,
>(
  _store?: TStore
) => {
  const useSelector: TypedUseSelectorHook<TState> = rrUseSelector;
  const useShallowSelector: TypedUseSelectorHook<TState> = selector =>
    rrUseSelector(selector, shallowEqual);

  const useDispatch = () => rrUseDispatch<TDispatch>();

  return { useSelector, useShallowSelector, useDispatch };
};
